import {  NgModule } from '@angular/core';
import { RetailerModule } from './retailers/retailer.module';
import {ProvidersModule} from './providers/providers.module'
import {ProductsModule}  from   './products/products.module'
import { WalletModule } from './wallet/wallet.module';
import { PromotionsModule } from './promotions/promotions.module';
import { ReportsModule } from './reports/reports.module';
import { ManageUsersModule } from './manage-users/manage-users.module';
import { MessagesModule } from './messages/messages.module';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '../features-common/services/authorization.service';
import { NavigationService } from '../features-common/services/navigation.service';
import { TranslateConfigService } from '../features-common/services/translate-config.service';
import { ProfileModule } from './profile/profile.module';
import { FeaturesCommonModule } from '../features-common/features-common.module';
import { ConsumerReportComponent } from './consumer-report/consumer-report.component';
import { ConsumerReportModule } from './consumer-report/consumer-report.module';


@NgModule({
  declarations: [],
  imports: [
    RetailerModule,
    ProductsModule,
    ProvidersModule,
    ManageUsersModule,
    WalletModule,
    ReportsModule,
    PromotionsModule,
    MessagesModule,
    ProfileModule,
    ConsumerReportModule
  ],
   providers: [
    
  ],
})
export class FeaturesModule { }
